export const APP_THEMES = ["theme-dark", "theme-light"];
